var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M938 111L938 139",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 938.5,
    cy: 106.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M933.987 106.19C933.987 102.283 937.288 99.1168 941.358 99.1168C941.943 99.1168 942.511 99.1841 943.056 99.3076C941.742 98.4804 940.187 98 938.519 98C933.814 98 930 101.806 930 106.5C930 111.194 933.814 115 938.519 115C940.814 115 942.895 114.093 944.427 112.62C943.492 113.032 942.454 113.263 941.358 113.263C937.288 113.263 933.987 110.096 933.987 106.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M947.402 105.6L947.37 103.146L945.535 104.719L943.304 104.056L944.112 106.337L942.765 108.381L945.1 108.218L946.499 110.144L947.133 107.763L949.345 106.909L947.402 105.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.f546123c64dcb89df134e622fad73b00.svg";
export { ForwardRef as ReactComponent };